const HeroDesktop = () => {
  return (
    <section className="w-full">
      <div className="relative aspect-[21/9] w-full overflow-hidden">
        <video
          src="https://assets.tea-n-tech.com/tea-n-tech-video-hero.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30 flex items-center">
          <div className="w-full max-w-7xl mx-auto px-6 lg:px-12">
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-4">
              Tea & Tech
            </h1>
            <p className="text-lg lg:text-xl text-white/90 max-w-2xl mb-6">
              Real talk about AI, software, and engineering. No buzzwords, just
              practical insights from the trenches.
            </p>
            <div className="flex gap-4">
              <a
                href="#about"
                className="bg-white text-black px-6 py-3 rounded-full font-medium hover:bg-white/90 transition-colors"
              >
                Our Story
              </a>
              <a
                href="#contact"
                className="border border-white text-white px-6 py-3 rounded-full font-medium hover:bg-white/10 transition-colors"
              >
                Let&apos;s Chat
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroDesktop;
